








import {Component, Prop, Vue} from 'vue-property-decorator';
import BoxTile from '@/components/ui/BoxTile.vue';
import TextContent from '@/components/ui/TextContent.vue';

@Component({
  components: {
    TextContent,
    BoxTile
  },
})
export default class GoalsLearnMore extends Vue {

  @Prop()
  public id!: string;

  get goalDetails() {
    return this.$store.getters.goalDetailById(this.id);
  }

  get content() {
    if (this.goalDetails && this.goalDetails.details) {
      return this.goalDetails.details.description;
    }
    return '';
  }

}
